import React from 'react'

import {
    List,
    ListItem,
    ListItemText,
    Paper,
    Divider,
    ListItemIcon,
} from '@material-ui/core'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import CancelIcon from '@material-ui/icons/Cancel'

import {
    ListVendor,
    ServiceContractGroup,
    PricingContractStatus,
} from '../../../models'

interface Props {
    pendingServiceContractGroups: ServiceContractGroup[]
    selectedVendor: ListVendor | null
    onVendorSelect: (vendor: ListVendor) => void
}

export const PendingVendorsPanel = (props: Props) => {
    const {
        pendingServiceContractGroups,
        selectedVendor,
        onVendorSelect,
    } = props

    return (
        <Paper
            style={{
                width: '300px',
                height: '100%',
                borderRight: '1px solid #e0e0e0',
                display: 'flex',
                flexDirection: 'column',
            }}
        >
            <List style={{ flex: 1, overflowY: 'auto' }}>
                {pendingServiceContractGroups.map((group, index) => {
                    // Get unique service IDs from service contracts
                    const uniqueServiceIds = Array.from(
                        new Set(
                            group.service_contracts.map((sc) => sc.service),
                        ),
                    )
                    const numServices = uniqueServiceIds.length

                    return (
                        <React.Fragment key={group.id}>
                            <ListItem
                                button
                                selected={
                                    selectedVendor?.id === group.vendor.id
                                }
                                onClick={() => onVendorSelect(group.vendor)}
                                style={{
                                    backgroundColor:
                                        selectedVendor?.id === group.vendor.id
                                            ? '#e3f2fd'
                                            : 'transparent',
                                }}
                            >
                                <ListItemIcon>
                                    {group.status ===
                                        PricingContractStatus.CURRENT && (
                                        <CheckCircleIcon
                                            style={{ color: 'green' }}
                                        />
                                    )}
                                    {group.status ===
                                        PricingContractStatus.REJECTED && (
                                        <CancelIcon style={{ color: 'red' }} />
                                    )}
                                </ListItemIcon>
                                <ListItemText
                                    primary={group.vendor.name}
                                    secondary={`${numServices} service(s)`}
                                />
                            </ListItem>
                            {index <
                                pendingServiceContractGroups.length - 1 && (
                                <Divider />
                            )}
                        </React.Fragment>
                    )
                })}
            </List>
        </Paper>
    )
}
